"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var axios_1 = __importDefault(require("axios"));
var material_1 = require("@mui/material");
var ModalLivestream_1 = __importDefault(require("./ModalLivestream"));
var RenderLivestream_1 = __importDefault(require("./RenderLivestream"));
var LivestreamHeader_1 = __importDefault(require("./LivestreamHeader"));
function GetLivestream() {
    var _this = this;
    var _a, _b, _c;
    var _d = (0, react_1.useState)(null), requestLivestream = _d[0], setLivestream = _d[1];
    var _e = (0, react_1.useState)(null), userRoles = _e[0], setUserRoles = _e[1];
    var _f = (0, react_1.useState)(null), isLive = _f[0], setIsLive = _f[1];
    var _g = (0, react_1.useState)(null), trackAttendance = _g[0], setTrackAttendance = _g[1];
    var _h = (0, react_1.useState)(''), attendanceMessage = _h[0], setAttendanceMessage = _h[1];
    var _j = (0, react_1.useState)([]), recentEvents = _j[0], setRecentEvents = _j[1];
    var _k = (0, react_1.useState)(null), language = _k[0], setLanguage = _k[1];
    var _l = (0, react_1.useState)(null), error = _l[0], setError = _l[1];
    var _m = (0, react_1.useState)(null), errorMessage = _m[0], setErrorMessage = _m[1];
    var _o = (0, react_1.useState)([]), statistics = _o[0], setStatistics = _o[1];
    var _p = (0, react_1.useState)(null), pollInterval = _p[0], setPollInterval = _p[1];
    var nameElement = document.getElementById('livestream-info');
    var name = JSON.parse((_a = nameElement.dataset.name) !== null && _a !== void 0 ? _a : '""');
    var _q = (0, react_1.useState)(''), enteredPassword = _q[0], setEnteredPassword = _q[1];
    (0, react_1.useEffect)(function () {
        var fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
            var livestreamResponse, livestreamData, lang, nextEventsEndpoint, recentEventsResponse, rolesResponse, err_1, livestreamResponse, livestreamData, display_before_login;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 5, , 11]);
                        return [4 /*yield*/, axios_1.default.get('/app/livestream/live/' + name)];
                    case 1:
                        livestreamResponse = _c.sent();
                        livestreamData = livestreamResponse.data;
                        lang = (_a = livestreamData.language) !== null && _a !== void 0 ? _a : null;
                        setLanguage(lang);
                        nextEventsEndpoint = lang === 'es' ? '/app/livestream/next-events/es' : '/app/livestream/next-events/en';
                        setLivestream(livestreamData);
                        setIsLive(livestreamData.is_live === 1);
                        setTrackAttendance(livestreamData.track_attendance === 1);
                        setAttendanceMessage((_b = livestreamData.attendance_message) !== null && _b !== void 0 ? _b : '');
                        return [4 /*yield*/, axios_1.default.get(nextEventsEndpoint)];
                    case 2:
                        recentEventsResponse = _c.sent();
                        setRecentEvents(recentEventsResponse.data);
                        if (!(name !== 'public-ticketed' && name !== 'entrada-publica')) return [3 /*break*/, 4];
                        return [4 /*yield*/, axios_1.default.get('/api/v2/students/?filter=roles')];
                    case 3:
                        rolesResponse = _c.sent();
                        setUserRoles(rolesResponse.data);
                        _c.label = 4;
                    case 4: return [3 /*break*/, 11];
                    case 5:
                        err_1 = _c.sent();
                        if (!(err_1.response && err_1.response.status === 401)) return [3 /*break*/, 9];
                        console.log('401 error', err_1);
                        if (!(name === 'minister' ||
                            name === 'ministerio' ||
                            name === 'initiate' ||
                            name === 'iniciados' ||
                            name === 'discourse' ||
                            name === 'disertacion')) return [3 /*break*/, 7];
                        return [4 /*yield*/, axios_1.default.get('/app/livestream/live/' + name)];
                    case 6:
                        livestreamResponse = _c.sent();
                        livestreamData = livestreamResponse.data;
                        display_before_login = livestreamData.display_before_login;
                        setErrorMessage(display_before_login !== null && display_before_login !== void 0 ? display_before_login : null);
                        return [3 /*break*/, 8];
                    case 7:
                        setErrorMessage('You do not have access to this stream');
                        _c.label = 8;
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        console.log('Error:', err_1);
                        setErrorMessage('An error occurred while loading the livestream data.');
                        _c.label = 10;
                    case 10:
                        setError(err_1);
                        return [3 /*break*/, 11];
                    case 11: return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, [name]);
    (0, react_1.useEffect)(function () {
        if (trackAttendance) {
            var fetchData_1 = function () { return __awaiter(_this, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, axios_1.default.get('/api/livestream/statistics/live')];
                        case 1:
                            result = _a.sent();
                            setStatistics(result.data.statistics);
                            return [2 /*return*/];
                    }
                });
            }); };
            fetchData_1();
            setPollInterval(setInterval(function () {
                fetchData_1();
            }, 6000));
            var handleBeforeUnload = function () {
                clearInterval(pollInterval);
            };
            window.addEventListener('beforeunload', handleBeforeUnload);
        }
    }, [trackAttendance]);
    var _r = (0, react_1.useState)('chat'), activeTab = _r[0], setActiveTab = _r[1];
    var _s = (0, react_1.useState)(false), isModalOpen = _s[0], setIsModalOpen = _s[1];
    function handleModalToggle() {
        setIsModalOpen(!isModalOpen);
    }
    if (!requestLivestream)
        return react_1.default.createElement(material_1.Box, null, "Loading...");
    if (isModalOpen) {
        return react_1.default.createElement(ModalLivestream_1.default, { isOpen: isModalOpen, onClose: handleModalToggle });
    }
    if (!language) {
        return react_1.default.createElement(material_1.Box, null, "Loading language...");
    }
    if (!isLive) {
        return (react_1.default.createElement(material_1.Box, null,
            react_1.default.createElement(LivestreamHeader_1.default, { language: language, requestLivestream: requestLivestream, handleModalToggle: handleModalToggle, recentEvents: recentEvents, name: name })));
    }
    var renderCommonProps = {
        requestLivestream: requestLivestream,
        setActiveTab: setActiveTab,
        activeTab: activeTab,
        error: error,
        errorMessage: errorMessage,
        enteredPassword: enteredPassword,
        setEnteredPassword: setEnteredPassword,
        trackAttendance: trackAttendance,
        attendanceMessage: attendanceMessage,
        statistics: statistics,
        setStatistics: setStatistics,
        pollInterval: pollInterval,
        setPollInterval: setPollInterval,
    };
    if (userRoles && userRoles.roles) {
        if (userRoles.roles.includes('administrator')) {
            return react_1.default.createElement(RenderLivestream_1.default, __assign({}, renderCommonProps, { publicLivestream: true }));
        }
        else if ((name === 'initiate' || name === 'iniciados') &&
            (requestLivestream.access_type === 'initiate' ||
                requestLivestream.access_type === 'iniciados') &&
            userRoles.roles.includes('initiate')) {
            return react_1.default.createElement(RenderLivestream_1.default, __assign({}, renderCommonProps, { publicLivestream: false }));
        }
        else if ((name === 'minister' || name === 'ministerio') &&
            (requestLivestream.access_type === 'minister' ||
                requestLivestream.access_type === 'ministerio') &&
            userRoles.roles.includes('minister')) {
            return react_1.default.createElement(RenderLivestream_1.default, __assign({}, renderCommonProps, { publicLivestream: false }));
        }
        else if ((name === 'minister-initiate' || name === 'ministerio-iniciados') &&
            (requestLivestream.access_type === 'minister-initiate' ||
                requestLivestream.access_type === 'ministerio-iniciados') &&
            (userRoles.roles.includes('minister') || userRoles.roles.includes('initiate'))) {
            return react_1.default.createElement(RenderLivestream_1.default, __assign({}, renderCommonProps, { publicLivestream: false }));
        }
        else if ((name === 'discourse' || name === 'disertacion') &&
            (requestLivestream.access_type === 'discourse' ||
                requestLivestream.access_type === 'disertacion') &&
            userRoles.roles.includes('discourse')) {
            return react_1.default.createElement(RenderLivestream_1.default, __assign({}, renderCommonProps, { publicLivestream: false }));
        }
        else if (requestLivestream.access_type === name &&
            userRoles.roles.includes(name)) {
            // Any system role can be configured as a livestream's access_type; when
            // the page slug matches the event's gate and the user holds that role,
            // render the stream — mirrors the server's generic capability check in
            // LivestreamController::userMayAccessLivestream().
            return react_1.default.createElement(RenderLivestream_1.default, __assign({}, renderCommonProps, { publicLivestream: false }));
        }
        else if (name === 'public-ticketed') {
            return react_1.default.createElement(RenderLivestream_1.default, __assign({}, renderCommonProps, { publicLivestream: true }));
        }
        else if (name === 'blessing-this-day' ||
            name === 'bendiciones-en-esta-dia' ||
            name === 'public' ||
            name === 'publico') {
            return react_1.default.createElement(RenderLivestream_1.default, __assign({}, renderCommonProps, { publicLivestream: true }));
        }
        else {
            var currentURLPath = window.location.pathname;
            var loginLink = "/app/students/login?previous_url=".concat(encodeURIComponent(currentURLPath));
            return (react_1.default.createElement(material_1.Box, { className: "error-message live-header", sx: { textAlign: 'center' } }, name === 'minister' ||
                name === 'ministerio' ||
                name === 'initiate' ||
                name === 'iniciados' ||
                name === 'disertacion' ||
                name === 'discourse' ? (react_1.default.createElement(material_1.Box, { className: "error-message live-header", sx: { textAlign: 'left' } },
                react_1.default.createElement(material_1.Typography, { dangerouslySetInnerHTML: {
                        __html: (_b = requestLivestream.display_after_login_non_access_type) !== null && _b !== void 0 ? _b : '',
                    } }))) : (react_1.default.createElement(material_1.Box, null,
                react_1.default.createElement(material_1.Typography, null, "You do not have access to this livestream. Contact customer service or login below."),
                react_1.default.createElement(material_1.Typography, null,
                    react_1.default.createElement(material_1.Button, { variant: "contained", href: loginLink, className: "button" }, "Click here to login"))))));
        }
    }
    else {
        if (name === 'blessing-this-day' ||
            name === 'bendiciones-en-esta-dia' ||
            name === 'public' ||
            name === 'publico') {
            return react_1.default.createElement(RenderLivestream_1.default, __assign({}, renderCommonProps, { publicLivestream: true }));
        }
        else {
            // SECURITY: restricted event with no confirmed authorizing role (unauthenticated, or a
            // malformed/empty roles response) must FAIL CLOSED — show the login prompt, never the stream.
            var currentURLPath = window.location.pathname;
            var loginLink = "/app/students/login?previous_url=".concat(encodeURIComponent(currentURLPath));
            return (react_1.default.createElement(material_1.Box, { className: "error-message live-header", sx: { textAlign: 'center' } }, name === 'minister' ||
                name === 'ministerio' ||
                name === 'initiate' ||
                name === 'iniciados' ||
                name === 'disertacion' ||
                name === 'discourse' ? (react_1.default.createElement(material_1.Box, { className: "error-message live-header", sx: { textAlign: 'left' } },
                react_1.default.createElement(material_1.Typography, { dangerouslySetInnerHTML: {
                        __html: (_c = requestLivestream.display_before_login) !== null && _c !== void 0 ? _c : '',
                    } }),
                react_1.default.createElement(material_1.Typography, null,
                    react_1.default.createElement(material_1.Button, { variant: "contained", href: loginLink, className: "button" }, "Click here to login")))) : (react_1.default.createElement(material_1.Box, null,
                react_1.default.createElement(material_1.Typography, null, "You do not have access to this livestream. Contact customer service or login below."),
                react_1.default.createElement(material_1.Typography, null,
                    react_1.default.createElement(material_1.Button, { variant: "contained", href: loginLink, className: "button" }, "Click here to login"))))));
        }
    }
}
exports.default = GetLivestream;
if (document.getElementById('livestream-info')) {
    react_dom_1.default.render(react_1.default.createElement(GetLivestream, null), document.getElementById('livestream-info'));
}
